import { c as _c } from "react/compiler-runtime";
import { PricePlanType } from '@systemeio/types';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
export function usePricePlanFilter() {
  const $ = _c(5);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => {
      if (user) {
        return "/api/dashboard/customer/price-plan/list";
      }
    };
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: pricePlanFilter
  } = useControlledSwr(t1, fetcher);
  let t2;
  if ($[3] !== pricePlanFilter) {
    t2 = {
      pricePlanFilter
    };
    $[3] = pricePlanFilter;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}